<template>
  <div class="services">
    <template v-for="service in services.services">
      <div class="service" v-observe-visibility="{ callback: animate, once: true }" :key="service.id">
        <v-icon :icon="service.icon_name"/>
        <div class="title">
          <h3>{{ service.title }}</h3>
        </div>
        <div class="description">
          <p>{{ service.description }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'services',
  props: {
    services: {
      type: Object,
    },
  },
  methods: {
    animate(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add('animate__animated', 'animate__fadeInUp');
      }
    },
  },
  components: {
    vIcon: () => import('@/components/icon'),
  },
};
</script>
